import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import DisabledComment from '../../../DisabledComment';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import s from './DisabledOrPrivateInfo.scss';
/** What we will display if a logged in user is unable to comment on a post for any reason. */
export var DisabledOrPrivateInfo = function (_a) {
    var _b = _a.commentsDisabledForAllUsers, commentsDisabledForAllUsers = _b === void 0 ? true : _b, isPaidFolder = _a.isPaidFolder, user = _a.user, authorName = _a.authorName, subproductId = _a.subproductId;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    if (commentsDisabledForAllUsers) {
        return React.createElement(DisabledComment, { title: t('commentbox.disabled') });
    }
    return (React.createElement(React.Fragment, null,
        !isMobile && (React.createElement(UserAvatar, { user: user, size: 50, className: s['avatar'], withLink: true })),
        React.createElement("div", { className: s['root'] }, isPaidFolder ? (React.createElement(React.Fragment, null,
            React.createElement(Premium, { size: IconSize.SMALL, className: s['icon'] }),
            React.createElement(Trans, { i18nKey: "commentbox.paywall.premiumFolders.locked", parent: "span" },
                React.createElement(BiLink, { href: subproductId ? Url.checkoutLink(subproductId) : undefined, className: s.link, biData: BiData({
                        evid: 2,
                        click_info: 'comment_unlock_paid_folder',
                        sectionname: BiContextProvidedValue,
                        widgetname: BiContextProvidedValue,
                        typeid: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                    }) }, 'Unlock'),
                " the artist's premium folder to join the discussion."))) : (React.createElement(React.Fragment, null,
            React.createElement(EyeDisc2, { size: IconSize.SMALL, className: s['icon'] }),
            React.createElement("span", null, t('commentbox.paywall.watchersFolders.locked', {
                postProcess: 'reactPostprocessor',
                author: React.createElement("span", null, authorName),
            })))))));
};
DisabledOrPrivateInfo.displayName = 'DisabledOrPrivateInfo';
export default DisabledOrPrivateInfo;
//# sourceMappingURL=DisabledOrPrivateInfo.js.map